import { Injectable } from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';
import { BehaviorSubject, Observable } from 'rxjs';
import { DocumentScannerInfos } from '../models';

@Injectable()
export class DocumentGedService {
	private subjectForm = new BehaviorSubject<UntypedFormGroup>(null);
	private filesToDeleteIds = new BehaviorSubject<string[]>([]);

	private documentsSubject = new BehaviorSubject<DocumentScannerInfos>(null);
	documents$ = this.documentsSubject.asObservable();

	sendDataForm(form: UntypedFormGroup): void {
		this.subjectForm.next(form);
	}

	getDataForm(): Observable<UntypedFormGroup> {
		return this.subjectForm.asObservable();
	}

	sendFilesToDeleteIds(ids: string[]): void {
		this.filesToDeleteIds.next(ids);
	}

	getFilesToDeleteIds(): Observable<string[]> {
		return this.filesToDeleteIds.asObservable();
	}

	initFilesToDeleteIds(): void {
		this.filesToDeleteIds.next([]);
	}

	/**
	 * Convert size in bytes to KB, MB, GB ...
	 * @param bytes
	 * @param decimals
	 * @returns Converted size
	 */
	formatBytes(bytes, decimals): string {
		if (bytes === 0) return '0 Octets';

		const k = 1024;
		const dm = decimals < 0 ? 0 : decimals;
		const sizes = ['Octet', 'Ko', 'Mo', 'Go', 'To', 'Po', 'Eo', 'Zo', 'Yo'];

		const i = Math.floor(Math.log(bytes) / Math.log(k));

		return parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + ' ' + sizes[i];
	}

	getDocumentsNumber(filesListField, documentMetadata, filesToDeleteIds): number {
		let totalDocs: number = 0;
		totalDocs += filesListField?.value ? filesListField?.value?.length : 0;
		totalDocs += documentMetadata?.length > 0 ? documentMetadata?.length : 0;
		return totalDocs - filesToDeleteIds?.length;
	}

	initValues(): void {
		this.subjectForm.next(null);
	}

	/**
	 *
	 * @param blob Binary
	 */
	addDocument(blob: Blob, fileName: string) {
		const currentDocs = this.documentsSubject.value;
		const listDocs: Blob[] = [blob];
		const docs: DocumentScannerInfos = {
			docs: listDocs,
			filename: `${fileName}_${this.formatDate(new Date())}.pdf`
		};
		this.documentsSubject.next(docs);
	}

	formatDate(date: Date): string {
		const day = String(date.getDate()).padStart(2, '0');
		const month = String(date.getMonth() + 1).padStart(2, '0');
		const year = date.getFullYear();
		const hours = String(date.getHours()).padStart(2, '0');
		const minutes = String(date.getMinutes()).padStart(2, '0');
		const seconds = String(date.getSeconds()).padStart(2, '0');

		return `${day}.${month}.${year}_${hours}h${minutes}m${seconds}s`;
	}

	/**
	 * Reset documentsSubject
	 */
	resetDocuments(): void {
		const docs: DocumentScannerInfos = {
			docs: null,
			filename: null
		};
		this.documentsSubject.next(docs); // Push an empty array to reset
	}
}
